import { useState, useEffect } from "react";
import { Typography, Row, Col, Input, Alert } from "antd";
import { useNavigate } from "react-router-dom";

const EditCompany = ({ id }) => {
  const [oldCompanyName, setOldCompanyName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyIndustry, setCompanyIndustry] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getACompany();
  }, []);

  const getACompany = async () => {
    try {
      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-company/${id}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      setOldCompanyName(result.companyName);
      setCompanyName(result.companyName);
      setCompanyIndustry(result.companyIndustry);
    } catch (error) {}
  };

  const updateCompany = async () => {
    if (companyName && companyIndustry) {
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/company-update/${id}`,
        {
          method: "PUT",
          body: JSON.stringify({
            oldCompanyName,
            companyName,
            companyIndustry,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(false);
        navigate(-1);
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      <Row className="add-row">
        <Col span={8}>
          <Typography.Text className="add-title">Şirkətin adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </Col>
        <Col span={8}>
          <Typography.Text className="add-title">
            Şirkət sektoru
          </Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={companyIndustry}
            onChange={(e) => setCompanyIndustry(e.target.value)}
          />
        </Col>
        <Col span={4}>
          <button
            disabled={buttonDisable}
            onClick={updateCompany}
            className="success-button"
          >
            Təsdiq Et
          </button>
        </Col>
        <Col span={4}>
          <button
            className="cancel-button"
            onClick={() => {
              navigate(-1);
            }}
          >
            İmtina Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default EditCompany;
